module.exports = __webpack_public_path__ + "img/Discord-Logo-White.28174a3.png";